import React from 'react';
import { motion } from 'framer-motion';
import { Leaf } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="py-16 md:py-24" data-id="element-120">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        scale: 0.98,
        y: 20
      }} whileInView={{
        opacity: 1,
        scale: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-sage text-white rounded-2xl p-8 md:p-12 shadow-xl relative overflow-hidden" data-id="element-122">
          {/* Decorative background elements */}
          <div className="absolute top-0 right-0 -mt-10 -mr-10 opacity-10" data-id="element-123">
            <Leaf className="w-64 h-64" data-id="element-124" />
          </div>

          <div className="relative z-10" data-id="element-125">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-white/20 mb-6 backdrop-blur-sm" data-id="element-126">
              <Leaf className="w-6 h-6 text-white" data-id="element-127" />
            </div>

            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white font-playfair" data-id="element-128">
              El Protocolo de Intervención Mimética
            </h2>

            <div className="space-y-6 text-lg md:text-xl text-white/90 font-lora leading-relaxed" data-id="element-129">
              <p data-id="element-130">
                Este manual no se trata de "remedios caseros" al azar. Se basa
                en la{' '}
                <strong className="text-white font-semibold" data-id="element-131">
                  Intervención Mimética
                </strong>
                : el uso de compuestos botánicos específicos (hidrolatos y
                aceites grado terapéutico) que imitan y apoyan la respuesta
                biológica del niño.
              </p>
              <p data-id="element-132">
                En lugar de bloquear la fiebre o el gas, este método acelera el
                proceso natural de alivio, reduciendo el tiempo de dolor sin
                efectos secundarios.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}